import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { IMAGE_URL } from "../utils/app_url";
import wishlistImg from "../assets/img/wishlist-icon2.svg";
import HeartIcon from "./HeartIcon";

const MAX_VARIANTS = 6;

const ProductCard = ({ product, handleAddWishlist, handleRemoveWishlist, isWishlistView = false,
    wishlistId = null, showStore = false, store = null, isStoreView = false, hideTag = false }) => {

    const currentWishlistId = wishlistId || product?.wishlist_id;
    const variants = product.colors || [];

    const [isWishlisted, setIsWishlisted] = useState(
        Boolean(currentWishlistId) || isWishlistView
    );

    // 1️⃣ Initial image = first variant image
    const [activeImage, setActiveImage] = useState(
        variants.length > 0 ? IMAGE_URL + variants[0].image : null
    );

    // 2️⃣ Track if user interacted (for active class)
    const [hasInteracted, setHasInteracted] = useState(false);

    const visibleVariants = variants.slice(0, MAX_VARIANTS);
    const remainingCount = variants.length - MAX_VARIANTS;



    const handleWishlistClick = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (isWishlisted) {
            if (currentWishlistId && handleRemoveWishlist) {
                setIsWishlisted(false); // ✅ optimistic OFF
                await handleRemoveWishlist(currentWishlistId);
            }
            return;
        }

        if (handleAddWishlist) {
            setIsWishlisted(true); // ✅ optimistic ON
            await handleAddWishlist(variants?.[0]?.product_id);
        }
    };

    useEffect(() => {
        setIsWishlisted(Boolean(currentWishlistId) || isWishlistView);
    }, [currentWishlistId, isWishlistView]);

    return (
        <li className="productItem">
            <div className="imgHolder">
                {/* Tag for product.tag or Bestseller/New */}
                {!hideTag && product?.tag && (
                    <span className={`product-tag`}>
                        {product?.tag}
                    </span>
                )}
                <Link to={`/product/${product.slug}`}>
                    <img
                        src={activeImage}
                        alt={product.title}
                        className={`prdtImg ${isStoreView ? "largeImg" : ""}`}
                    />
                </Link>
                <div className="wishlistItem">
                    <HeartIcon
                        active={isWishlisted}
                        onClick={handleWishlistClick}
                    />
                </div>
            </div>


            <div className="prdtCaption">

                {/* 4️⃣ Show picker ONLY if more than 1 variant */}
                {variants.length > 1 && (
                    <div className="colorVariants">
                        {visibleVariants.map((variant) => (
                            <span
                                key={variant.product_id}
                                className={`colorThumb ${hasInteracted &&
                                    activeImage === IMAGE_URL + variant.image
                                    ? "active"
                                    : ""
                                    }`}
                                title={variant.color}
                                onMouseEnter={() => {
                                    setActiveImage(IMAGE_URL + variant.image);
                                    setHasInteracted(true);
                                }}
                                onClick={() => {
                                    setActiveImage(IMAGE_URL + variant.image);
                                    setHasInteracted(true);
                                }}
                            >
                                <img
                                    src={IMAGE_URL + variant.image}
                                    alt={variant.color}
                                />
                            </span>
                        ))}

                        {/* 3️⃣ +N indicator */}
                        {remainingCount > 0 && (
                            <span className="colorMore">+{remainingCount}</span>
                        )}
                    </div>
                )}

                <Link to={`/product/${product.slug}`}>

                    {parseInt(product?.is_public) === 1 && (
                        <h3>
                            {product.currency}
                            {product.sale_price && Number(product.sale_price) > 0
                                ? product.sale_price
                                : product.price}

                            {product.sale_price && Number(product.sale_price) > 0 && (
                                <span>
                                    {product.currency}
                                    {product.price}
                                </span>
                            )}
                        </h3>
                    )}


                    <h2>{product.title}</h2>
                </Link>
                

            </div>

        </li >
    );
};

export default ProductCard;
